import {Injectable} from '@angular/core';
import { Router, UrlSegment } from '@angular/router';

@Injectable()
export class RouterService {
    constructor(private router: Router) {

    }
    isActiveRoute(segment: string) {
        const url = window.location.pathname;
        const urlTree = this.router.parseUrl(url);

        const root: any = urlTree.root;
        // primary is only accessable with any
        const segments = <UrlSegment[]> root.children.primary.segments;
        for (var i = 0; i < segments.length; i++) {
            const currengSegment = segments[i];
            if (currengSegment.path == segment) {
                return true;
            }

        }
        return false;
    }

}
